import {
    Banner,
    BannerDescription,
    BannerImage,
    BannerImageContainer,
    BannerLinks,
    BannerText,
    BannerTextContainer,
    BannerTitle,
    Button,
    FluidImage,
    Link,
    P,
    tokensRaw,
} from '@vp/swan';
import styled from 'styled-components';
import { __, __image, __url } from '@99designs/i18n';
import { sendNavigationEvent, usePage } from '@99designs/tracking';
import { CloudinaryImage } from '../CloudinaryImage';

const StyledBannerImage = styled(FluidImage)`
    @media (max-width: ${tokensRaw.SwanBaseBreakpointXsEnd}) {
        border-radius: ${tokensRaw.SwanSemBorderRadiusContainer};
    }
`;

export function PackagingSampleBanner() {
    const { pageData } = usePage();
    const onClickTracking = () => {
        sendNavigationEvent({
            label: 'Content:Packaging Sample Banner',
            eventDetail:
                '/design/packaging;/packaging/packaging-samples;Packaging Sample Banner;BrowseSamples-CTA',
            navigationDetail: 'BrowseSamples-CTA',
            ...pageData,
        });
    };

    return (
        <Banner
            variant="full-width-image"
            height="short"
            bgc={{ xs: 'transparent', sm: 'standard' }}
        >
            <BannerTextContainer>
                <BannerText>
                    <BannerTitle as="h2">{__('Order a packaging sample today!')}</BannerTitle>
                    <BannerDescription>
                        <P>
                            {__(
                                'Try the packaging that’ll suit your needs and products so you can order more in confidence.'
                            )}
                        </P>
                    </BannerDescription>
                    <BannerLinks>
                        <Button
                            skin="primary"
                            render={(props) => (
                                <Link
                                    onClick={onClickTracking}
                                    to={__url('/packaging/packaging-samples')}
                                    className={props.className}
                                >
                                    {props.children}
                                </Link>
                            )}
                        >
                            {__('Browse samples')}
                        </Button>
                    </BannerLinks>
                </BannerText>
            </BannerTextContainer>
            <BannerImageContainer>
                <BannerImage>
                    <CloudinaryImage
                        render={(props) => (
                            <StyledBannerImage
                                src={props.src}
                                srcSet={props.srcSet}
                                alt=""
                                role="presentation"
                            />
                        )}
                        imagePath={__image(
                            'expert_services/DesignCategoryPage/Packaging/PackagingSampleBanner'
                        )}
                    />
                </BannerImage>
            </BannerImageContainer>
        </Banner>
    );
}
